import React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Home from "./pages/Home";
import Homologacao from "./pages/Homologacao";
import Reconhecimento from "./pages/Reconhecimento";
import Contacto from "./pages/Contacto";


const Routes = () =>(
    <BrowserRouter>
        <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/homologacao" component={Homologacao} />
            <Route path="/reconhecimento" component={Reconhecimento} />
            <Route path="/contacto" component={Contacto} />
        </Switch>
    </BrowserRouter>
)

export default Routes;